import { ActionCreator } from 'redux';

import { Email } from '@dev/ee-api/ee-api-models';
import { EmailsState, ViewEmailStartAction, ViewEmailErrorAction, ViewEmailSuccessAction, ClearViewEmailAction } from './types';
import { ApplicationState } from '..';

export const getEmailsStore = (state: ApplicationState): EmailsState => state.emails;

export const ViewEmailStart: ActionCreator<ViewEmailStartAction> = (msgid: string): ViewEmailStartAction => {
    return {
        type: '@@emails/VIEW_START',
        payload: {
            msgid,
            emailLoading: true,
        },
    };
};

export const ViewEmailError: ActionCreator<ViewEmailErrorAction> = (): ViewEmailErrorAction => {
    return {
        type: '@@emails/VIEW_ERROR',
        payload: {
            emailLoading: false,
        },
    };
};
export const ClearViewEmail = (): ClearViewEmailAction => {
    return {
        type: '@@emails/CLEAR_VIEW_EMAIL',
    };
};

export const ViewEmailSuccess: ActionCreator<ViewEmailSuccessAction> = (email: Email): ViewEmailSuccessAction => {
    return {
        type: '@@emails/VIEW_SUCCESS',
        payload: {
            email,
            emailLoading: false,
        },
    };
};
